<div class="countdown">
    <div class="countdown-days">
        {{ (days | number: '2.0-0') || '--' }}
        <span>{{ 'shared.date.days' | translate }}</span>
    </div>
    <div class="countdown-symbol">:</div>
    <div class="countdown-hours">
        {{ (hours | number: '2.0-0') || '--' }}
        <span>{{ 'shared.date.hours' | translate }}</span>
    </div>
    <div class="countdown-symbol">:</div>
    <div class="countdown-minutes">
        {{ (minutes | number: '2.0-0') || '--' }}
        <span>{{ 'shared.date.minutes' | translate }}</span>
    </div>
    <div class="countdown-symbol">:</div>
    <div class="countdown-seconds">
        {{ (seconds | number: '2.0-0') || '--' }}
        <span>{{ 'shared.date.seconds' | translate }}</span>
    </div>
</div>
